'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _immutable = require('immutable');

var _PubNubStatusRecord = require('conversations-schema/records/PubNubStatusRecord');

var _PubNubStatusRecord2 = _interopRequireDefault(_PubNubStatusRecord);

var _helpers = require('conversations-core/utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MAX_HISTORY_SIZE = 10000;

var initialState = (0, _immutable.fromJS)({
  statusHistory: [],
  statusByChannel: {},
  visiblyOffline: false,
  isResubscribing: false,
  resubscribeCounts: {
    session: 0,
    recent: 0
  }
});

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.RECEIVED_PUBNUB_STATUS, function (state, action) {
  var pubNubStatus = (0, _PubNubStatusRecord2.default)(action.payload);
  return state.set('statusHistory', state.get('statusHistory').unshift(pubNubStatus).take(MAX_HISTORY_SIZE)).mergeIn(['statusByChannel'], pubNubStatus.affectedChannels.reduce(function (newStatuses, channel) {
    return newStatuses.set(channel, pubNubStatus);
  }, (0, _immutable.Map)()));
}), _defineProperty(_handleActions, _ActionTypes2.default.NETWORK_OFFLINE, function (state) {
  return state.set('visiblyOffline', true);
}), _defineProperty(_handleActions, _ActionTypes2.default.NETWORK_ONLINE, function (state) {
  return state.set('visiblyOffline', false);
}), _defineProperty(_handleActions, _ActionTypes2.default.START_CHANNEL_SUBSCRIBE_POLL, function (state) {
  return state.set('isResubscribing', true);
}), _defineProperty(_handleActions, _ActionTypes2.default.INCREMENT_CHANNEL_SUBSCRIBE_COUNT, function (state) {
  return state.update('resubscribeCounts', function (resubscribeCounts) {
    return resubscribeCounts.merge({
      session: resubscribeCounts.get('session') + 1,
      recent: resubscribeCounts.get('recent') + 1
    });
  });
}), _defineProperty(_handleActions, _ActionTypes2.default.SUBSCRIBE_CONFIRMATION, function (state, action) {
  var channels = action.payload;
  var isPollingSubscribe = state.get('isResubscribing');

  if ((0, _helpers.containsPrivateChannel)(channels) && isPollingSubscribe) {
    return state.update(function (currentState) {
      return currentState.mergeDeep({
        isResubscribing: false,
        resubscribeCounts: {
          recent: 0
        }
      });
    });
  }

  return state;
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/pubNubStatus.js
// module id = 513
// module chunks = 0